import { Component, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import {
  InfiniteScrollingService,
  equalsCompare,
  numberComparer
} from '@ipreo/muni-shared';
import { MonitorPriorityPageService } from '../../../services/monitor-priority-page.service';
import { MonitorOverviewViewItem } from '../../../models/monitor';
import {
  performFinalTransformations,
  transformTotals
} from '../../../mappers/monitor-base-page.calculations';
import {
  MonitorBasePageComponent,
  monitorBasePageSassVariables
} from '../base-monitor-tab.component';
import { NegativeCasesService } from '../../../../gameday/services/negative-cases.service';
import { CellClassParams } from 'ag-grid-community';
import { ColumnDefinition } from '../../../../models/column';

// @dynamic
@Component({
  providers: [MonitorPriorityPageService],
  selector: 'muni-gameday-monitor-priority-page',
  templateUrl: './monitor-priority-page.template.html',
  styleUrls: ['../base-monitor-tab.styles.scss'],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['dataSource'],
  // eslint-disable-next-line @angular-eslint/no-outputs-metadata-property
  outputs: ['maturityClick']
})
export class MonitorPriorityPageComponent
  extends MonitorBasePageComponent<MonitorPriorityPageService>
  implements OnDestroy {
  static columnDefinition: ColumnDefinition[] = [
    {
      field: 'total',
      headerName: 'Total Priority',
      label: 'Total Priority',
      comparator: numberComparer,
      position: 999,
      suppressMenu: true,
      type: 'numericColumn'
    },
    {
      field: 'balance',
      headerName: 'Priority Balance',
      label: 'Priority Balance',
      comparator: numberComparer,
      position: 1001,
      width: 110,
      minWidth: 110,
      maxWidth: 110,
      cellStyle: ({ value }: CellClassParams) => {
        return value > 0
          ? { color: monitorBasePageSassVariables.colorRedDarker }
          : null;
      },
      suppressMenu: true,
      type: 'numericColumn'
    },
    {
      field: 'subscription',
      headerName: 'Priority Subscription',
      label: 'Priority Subscription',
      comparator: numberComparer,
      position: 1002,
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      cellStyle: ({ value }: CellClassParams) => {
        return value < 1
          ? { color: monitorBasePageSassVariables.colorRedDarker }
          : null;
      },
      suppressMenu: true,
      type: 'numericColumn'
    },
    ...MonitorBasePageComponent.columnDefinition
  ];

  static notCategories: string[] = MonitorPriorityPageComponent.columnDefinition.map(
    (item) => item.field
  );

  public readonly categories = this.monitorPageService.getCategories();

  public readonly data: Observable<
    MonitorOverviewViewItem[]
  > = this.monitorPageService
    .getDataCombinedByMaturities()
    .pipe(
      map((data) =>
        data.map((item) =>
          performFinalTransformations(
            item,
            MonitorPriorityPageComponent.notCategories
          )
        )
      )
    );

  public readonly totals: Observable<MonitorOverviewViewItem> = this.monitorPageService
    .calculateTotals()
    .pipe(
      map((totals) =>
        transformTotals(totals, MonitorPriorityPageComponent.notCategories)
      )
    );

  public readonly columnDefinitions: Observable<
    ColumnDefinition[]
  > = this.monitorPageService
    .getColumnDefinitions(
      MonitorPriorityPageComponent.columnDefinition,
      this.categories
    )
    .pipe(distinctUntilChanged(equalsCompare)); // checked, makes sense

  constructor(
    monitorPageService: MonitorPriorityPageService,
    negativeCasesService: NegativeCasesService,
    infiniteScrollingService: InfiniteScrollingService
  ) {
    super(monitorPageService, negativeCasesService, infiniteScrollingService);
  }

  public ngOnDestroy(): void {
    super.onDestroy();
  }
}
